import { useState } from "react";
import { Menu, X } from "lucide-react";

const NAV = [
  { label: "Services", id: "services" },
  { label: "Why Us", id: "why-us" },
  { label: "Process", id: "process" },
  { label: "Testimonials", id: "testimonials" },
  { label: "Contact", id: "contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    setOpen(false);
  };

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 w-full bg-[#FAFAFA] border-b-4 border-gray-900"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-4 flex items-center justify-between">
        <button
          data-testid="logo-link"
          onClick={() => scrollTo("hero")}
          className="flex items-center"
          aria-label="Paragon IT Services — home"
        >
          <img
            src="/paragon-logo.png"
            alt="Paragon IT Services Pvt. Ltd."
            className="h-10 md:h-12 w-auto block"
          />
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((item) => (
            <button
              key={item.id}
              data-testid={`nav-${item.id}`}
              onClick={() => scrollTo(item.id)}
              className="font-bold text-gray-900 hover:text-[#FF477E] transition-colors text-base"
            >
              {item.label}
            </button>
          ))}
        </nav>

        <button
          data-testid="header-cta"
          onClick={() => scrollTo("contact")}
          className="hidden md:inline-flex bg-[#FBD46D] text-gray-900 border-[3px] border-gray-900 font-bold px-5 py-2.5 rounded-lg nb-shadow-sm nb-hover"
        >
          Let's Talk
        </button>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden nb-border-sm rounded-lg p-2"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden border-t-4 border-gray-900 bg-white">
          <div className="flex flex-col p-6 gap-4">
            {NAV.map((item) => (
              <button
                key={item.id}
                data-testid={`mobile-nav-${item.id}`}
                onClick={() => scrollTo(item.id)}
                className="text-left font-bold text-lg py-2 border-b-2 border-gray-200"
              >
                {item.label}
              </button>
            ))}
            <button
              data-testid="mobile-cta"
              onClick={() => scrollTo("contact")}
              className="bg-[#FF477E] text-white border-[3px] border-gray-900 font-bold px-5 py-3 rounded-lg nb-shadow-sm"
            >
              Let's Talk
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
